import {createSelector} from '@reduxjs/toolkit';

import {isDirectMessagesChannelCategory} from '../utils/isDirectMessagesChannelCategory';

import {getAllChannelCategoriesByIds} from './get_all_channel_categories_by_ids';

export const getDirectMessagesChannelCategories = createSelector(getAllChannelCategoriesByIds, (categories) => {
    return Object.values(categories).filter(isDirectMessagesChannelCategory);
});
